
import ErrorPage from '../containers/ErrorPage/ErrorPage';


export default function ErrorGatekeeper() {
    return <ErrorPage />;
}